"use client"

import { useLocale } from "./localeContext"

const translations = {
  es: {
    pagina_principal: "Página Principal",
    oferta_academica: "Oferta Académica",
    preguntas_frecuentes: "Preguntas Frecuentes",
  }
}

export const useTranslations = () => {
  const { locale } = useLocale()

  const t = (key) => {
    return translations[locale]?.[key] || translations.es[key] || key
  }

  return { t }
}
